import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { EnrichedParentStopPlace, EnrichedStopPlace } from '../../../types';
import { showWarningToast } from '../../../utils';
import { isDateInRange, parseDate } from '../../../utils/time';
import { useMapUrlStateContext } from './mapUrlState';

export function useSetMapObservationDate() {
  const { t } = useTranslation();

  const {
    state: {
      filters: { observationDate },
    },
    setFlatUrlState,
  } = useMapUrlStateContext();

  return useCallback(
    (stopPlace: EnrichedParentStopPlace | EnrichedStopPlace | null) => {
      const validityStart = parseDate(stopPlace?.validityStart);
      const validityEnd = parseDate(stopPlace?.validityEnd);

      if (!isDateInRange(observationDate, validityStart, validityEnd)) {
        setFlatUrlState((p) => ({
          ...p,
          observationDate: validityStart ?? validityEnd ?? observationDate,
        }));
        showWarningToast(t(($) => $.filters.observationDateAdjusted));
      }
    },
    [observationDate, t, setFlatUrlState],
  );
}
